import { useSignal } from "@preact/signals-react"
import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import {clearSignals, isTableLoading, tableData, tableFormsData} from "Pages/Admin/OfficeMapping/@signals"
import { offices, sites } from "@signals"

export default function useOfficeMappingFilter() {
	const backupTable = useSignal([])
	const company = useSignal(null)
	const markets = useSignal([])
	const officeTypes = useSignal([])
	const sitesOptions = useSignal([])
	const { showToast } = useToast()
	const submitFilters = useCallback(() => {
		if (offices.value && company.value) {
			isTableLoading.value = true
			getSubmit(`${BACKEND_APIS.OFFICE_MAPPING}/office`, { idOffice: offices.value, company: company.value })
				.then(res => {
					if (!!sites.value?.length) {
						tableData.value = [...res.officeConfig?.filter(({ name }) => sites.value.includes(name))]
					} else {
						tableData.value = res.officeConfig
					}
					backupTable.value = res.officeConfig
					sitesOptions.value = res.sites.map(site => ({
						value: site,
						label: res.siteMarkets[site]
					}))
					isTableLoading.value = false
				})
				.catch(() => {
					showToast.error()
					isTableLoading.value = false
				})
		}
	}, [company.value, offices.value])

	const handleChangeOffice = useCallback(value => {
		offices.value = value
		clearSignals()
	}, [])

	const handleChangeCompany = useCallback(value => {
		company.value = value
		markets.value = []
		officeTypes.value = []
		sites.value = []
		clearSignals()
	}, [])

	const handleChangeMarkets = useCallback(value => {
		markets.value = value || []
		offices.value = null
		clearSignals()
	}, [])

	const handleChangeOfficeTypes = useCallback(value => {
		officeTypes.value = value || []
		offices.value = null
		clearSignals()
	}, [])

	const handleChangeSite = useCallback(value => {
		sites.value = value
		if (!!value?.length) {
			tableData.value = [...backupTable.value?.filter(({ name }) => value.includes(name))]
		} else {
			backupTable.value = backupTable.value.map(row => {
				const modifiedRow = tableData.value.find(r => r.idSite === row.idSite)
				return modifiedRow ? { ...row, ...modifiedRow } : row
			})
			tableData.value = backupTable.value
			tableFormsData.value = backupTable.value.map(row => ({ ...row.fieldData }))
		}
	}, [])

	const marketsFilter = markets.value?.length ? markets.value.join(',') : undefined
	const officeTypesFilter = officeTypes.value?.length ? officeTypes.value.join(',') : undefined

	return {
		submitFilters,
		handleChangeCompany,
		handleChangeOffice,
		handleChangeSite,
		handleChangeMarkets,
		handleChangeOfficeTypes,
		sitesOptions: sitesOptions.value,
		company: company.value,
		office: offices.value,
		sites: sites.value,
		markets: markets.value,
		officeTypes: officeTypes.value,
		marketsFilter,
		officeTypesFilter,
	}
}